import { baseService } from "src/store/base.store";
import { executeQuery } from "src/store";
import { aiLanguageVoiceRepository } from "./ai-language-voice.repository";
import { AiLanguageVoice } from "./entities/ai-language-voice.entity";

export type AILanguageVoiceFilter = Partial<Pick<AiLanguageVoice, "langCode" | "language" | "voiceSource">>;

const aiLanguageVoicesService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getAILanguageVoices: builder.query<(AiLanguageVoice & { id: string })[], { where?: AILanguageVoiceFilter; offset?: string }>({
      queryFn: async ({ where = {}, offset }) => {
        const result = await executeQuery(() =>
          aiLanguageVoiceRepository.find({ where, offset, orderBy: ["language", "asc"] } as any)
        );
        if ("error" in result) {
          return { error: result.error } as any;
        }
        return { data: (result.data as unknown) as (AiLanguageVoice & { id: string })[] };
      },
    }),

    countAILanguageVoices: builder.query<number, { where?: AILanguageVoiceFilter }>({
      queryFn: async ({ where = {} }) => {
        return executeQuery(() => aiLanguageVoiceRepository.count(where as any)) as any;
      },
    }),

    deleteAILanguageVoice: builder.mutation<void, { id: string }>({
      queryFn: async ({ id }) => {
        try {
          await aiLanguageVoiceRepository.delete(id);
          return { data: undefined };
        } catch (error) {
          return { error: { status: "CUSTOM_ERROR", error: "Failed to delete AI language voice" } } as any;
        }
      },
    }),

    updateAILanguageVoice: builder.mutation<void, { id: string; updates: Partial<AiLanguageVoice> }>({
      queryFn: async ({ id, updates }) => {
        try {
          await aiLanguageVoiceRepository.update(id, updates);
          return { data: undefined };
        } catch (error) {
          return { error: { status: "CUSTOM_ERROR", error: "Failed to update AI language voice" } } as any;
        }
      },
    }),
  }),
});

export const {
  useGetAILanguageVoicesQuery,
  useCountAILanguageVoicesQuery,
  useDeleteAILanguageVoiceMutation,
  useUpdateAILanguageVoiceMutation,
} = aiLanguageVoicesService;
